<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="8" nzXl="6">
        <h1 class="page-title">Warehouse</h1>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="18" class="btnsearch">
        <div class="header-right-box">
            <a (click)="physicalInventoryShow(false)" class="mr-1 ant-btn-link">Convert Wayfair CSV File</a>
            <a (click)="physicalInventoryShow(true)" class="mr-1 ant-btn-link">Physical Inventory Reconciliation</a>
            <!-- <input type="file" style="display:none" #fileInput (change)=""
                                accept=".csv"> 
                            fileInput.click()-->
            <button nz-button nzType="primary" class="right_margin new-btn" (click)="syncRetailPrices()" [nzLoading]="isSyncingPrices" [disabled]="isSyncingPrices"><i nz-icon nzType="sync" nzTheme="outline"></i> Sync Retail Prices</button>
            <button nz-button nzType="primary" class="right_margin new-btn" (click)="isVisiblePartsModal = true"><i
                nz-icon nzType="plus"></i>Import Parts</button>
            <button nz-button nzType="primary" class="right_margin new-btn" (click)="showModal();getPartNumbers()"><i
                    nz-icon nzType="plus"></i> New</button>
            <input type="text" class="right_margin search-input" nz-input
                placeholder="Search here by type at least 3 character ..." [(ngModel)]="searchText"
                (keyup)="onSearch($event)" />
            <i nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip
                nzTooltipTitle="You need to wait for 3 seconds after search apply"></i>
        </div>
    </div>
</div>

<div class="table-height warehousescreen" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <nz-table class="main-table-header" #sortTable [nzData]="lst_Warehouse" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' : lst_Warehouse?.length > 0 || isDashboardLoaded}">
        <thead>
            <tr class="tableheader">
                <th nzWidth="50px">#</th>
                <th nzWidth="100px" [nzAlign]="'left'" (nzSortOrderChange)="sort('name')" [nzSortFn]="true"><span
                        class="stock-name-th"> Part Number</span>
                </th>
                <th [nzAlign]="'right'" nzWidth="100px">Physical Quantity</th>
                <th [nzAlign]="'right'" nzWidth="100px">Available Quantity</th>
                <th [nzAlign]="'right'" nzWidth="80px">Assigned</th>
                <th [nzAlign]="'left'" nzWidth="130px">Notes</th>
                <th [nzAlign]="'right'" nzWidth="110px">Retail Price</th>
                <th [nzAlign]="'right'" nzWidth="150px" nzEllipsis> <span [nzTooltipArrowPointAtCenter]="true"
                        [nzTooltipPlacement]="['top']" nz-tooltip>Action</span></th>
            </tr>
        </thead>
        <tbody *ngIf="!isDashboardLoaded">
            <tr *ngFor="let list of lst_Warehouse;let  i = index;let even= even;" [ngClass]="{'is-even-row': even}">
                <td nzWidth="50px">{{i+1}}</td>
                <td nzWidth="100px">{{list.partNumber}}</td>
                <td [nzAlign]="'right'" nzWidth="100px">{{list.physicalPartQuantity}}</td>
                <td [nzAlign]="'right'" nzWidth="100px">{{list.availbleQuantity}}</td>
                <td [nzAlign]="'right'" nzWidth="80px">
                    <a nzType="link" nz-button nz-popover [nzPopoverTitle]="titleTemplate" class="pointer"
                        *ngIf="list.assignedQuantity > 0" [nzPopoverPlacement]="'rightTop'"
                        [(nzPopoverVisible)]=" list.visibleAssigned"
                        (nzPopoverVisibleChange)="GetAssignmentDetails(list.id ,list.partNumber,i)"
                        [nzPopoverContent]="contentTemplate">{{ list.assignedQuantity }}
                    </a>
                    <a class="restrict-pointer" nzType="link" nz-button *ngIf="list.assignedQuantity == 0">0</a>

                    <div class="assiged-list-heigth">
                        <ng-template #titleTemplate>
                            Assigned To <img class="float-right close-icon" src="./assets/images/Close.svg"
                                (click)="GetAssignmentDetails(list.id ,list.partNumber,i)">
                        </ng-template>
                        <ng-template #contentTemplate>
                            <ng-container>
                                <p *ngFor="let a of list?.assignmentList; let ai = index;">
                                    <span
                                        [ngClass]="{'pay-paid' :a.qB_PaymentStatus == 'Paid', 'pay-unpaid' :a.qB_PaymentStatus == 'UnPaid','pay-partial' :a.qB_PaymentStatus == 'PartiallyPaid'}">
                                        <i nzTheme="fill" nz-icon nzType="user" nzTheme="outline"
                                            class="right_margin"></i>
                                        <a class="assignlink"
                                            [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+a.transactionID"
                                            target="_blank">{{ a.invoiceNo }}</a> - {{a.customerName }} - <a
                                            (click)="showAssignmentEdit(a)">({{a.assignedQuantity}})</a></span>
                                </p>
                                <div *ngIf="list.assignmentList?.length == 0">
                                    <span class="no-any-assignment">No any assignment</span>
                                </div>
                            </ng-container>
                            <i nz-icon [nzType]="'loading'" *ngIf="!list?.assignmentList"></i>
                        </ng-template>
                    </div>
                </td>
                <td [nzAlign]="'left'" nzWidth="130px" class="note-column">{{list.note}}</td>
                <td [nzAlign]="'right'" nzWidth="110px">{{ list.retailPrice != null ? (list.retailPrice | currency:'USD':'symbol':'1.2-2') : '—' }}</td>
                <td [nzAlign]="'right'" nzWidth="150px"><a class="mr-1" (click)="showHistoryModal(list)"
                        nzCancelText="cancel"><img src="../assets/images/Audit-Icon.png"></a></td>
            </tr>
        </tbody>
        <ng-container *ngIf="isDashboardLoaded">
            <tbody>
                <tr *ngFor="let i of [].constructor(100)">
                    <ng-container *ngFor="let i of [].constructor(8)">
                        <td [nzAlign]="'left'" class="loading">
                            <div class="bar"></div>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </ng-container>
    </nz-table>
</div>


<nz-modal [nzVisible]="isVisibleAddWarehouse" nzClassName="AddWarehouse" nzTitle="Add/Edit Warehouse Stock"
    (nzOnCancel)="AddWarehouseCancel()">
    <ng-container *nzModalContent>
        <div class="modal-height">
            <form nz-form class="modal" [formGroup]="_fS.addWarehouseStock">
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control nzErrorTip="Part number is required" nzRequired
                                class="input-field input-box required-input-icon">
                                <nz-form-label nzRequired class="modal-label">Part Number</nz-form-label>
                                <nz-select formControlName="partNumber" nzShowSearch nzPlaceHolder="Select Part Number"
                                    (ngModelChange)="onSelectPartNumber($event)">
                                    <nz-option [nzValue]=c.value [nzLabel]=c.text *ngFor="let c of lst_Parts">
                                    </nz-option>
                                </nz-select>
                                <span class="text-danger"
                                    *ngIf="isPartNumberExist && !_fS.addPartNumberForm.controls['partNumber'].hasError('required')">
                                    Part number is already added
                                </span>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control nzErrorTip="Quantity is required"
                                class="input-field input-box required-input-icon">
                                <nz-form-label nzRequired nzFor="Name" class="modal-label">Quantity</nz-form-label>
                                <input type="number" class="input" nz-input formControlName="orderQuantiry"
                                    placeholder="Enter Quantity" step="1"
                                    (keypress)="_cS.validateNumber($event,true)" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                        <nz-form-item>
                            <nz-form-control>
                                <nz-form-label nzFor="notes" class="modal-label">Notes</nz-form-label>
                                <textarea id="notes" class="input" nz-input formControlName="notes" rows="2"
                                    maxlength="200" placeholder="Enter Notes"></textarea>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                        <nz-form-item class="mb-0 text-right">
                            <nz-form-control>
                                <button nz-button nzType="default" (click)="AddWarehouseCancel()"
                                    class="modal-footer-btn cancel-btn right_margin">Cancel</button>
                                <button class="btn-blue modal-footer-btn" (click)="AddWarehouseOk()" nz-button
                                    nzType="primary">Save</button>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>

</nz-modal>


<input class="file-input" type="file" hidden #fileReadedJS name="" id='fileReadedJS' (change)="uploadListener($event)">


<nz-modal [nzVisible]="physicalInventoryisVisible" [nzMaskClosable]="false" (nzOnCancel)="physicalInventoryCancel()"
    nzClassName="physicalInventoryModal" [nzTitle]="isPhysicalModal ? 'Physical Inventory Reconciliation' : 'Convert Wayfair CSV File'">
    <ng-container *nzModalContent>
        <div class="UploadFile" *ngIf="uploadFile">
            <div class="download" *ngIf="isPhysicalModal">
                <a (click)="DownloadPhysicalInventoryTemplate()">Download template with part number</a>
            </div>
            <nz-form-control>
                <div class="file-drop-area" (click)="fileReadedJS.click()">
                    <i nz-icon class="inboxIcon" nzType="inbox" nzTheme="outline"></i><br><br>
                    <p class="ant-upload-text"> Choose CSV file <br>OR <br>Drag and
                        drop CSV file here</p>
                </div>
                <div class="uploadtext converFileModal-uploadText" *ngIf="fileNmae">
                    {{this.fileReaded?.name}} <span *ngIf="!isPhysicalModal"><button class="btn-blue modal-footer-btn" (click)="convertCSVFile()" nz-button
                        nzType="primary" [disabled]="isConvertingFile">{{ isConvertingFile ? 'Converting' : 'Convert'}}</button></span>
                </div>
            </nz-form-control>

            <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                <nz-form-item class="mb-0 text-right">
                    <nz-form-control>
                        <button nz-button nzType="default" (click)="physicalInventoryCancel()"
                            class="modal-footer-btn cancel-btn right_margin">Cancel</button>
                        <button *ngIf="isPhysicalModal" class="btn-blue modal-footer-btn" (click)="physicalInventoryOk()" nz-button
                            nzType="primary" [disabled]="isDisabled">{{'Preview' }}</button>
                        <button *ngIf="!isPhysicalModal" class="btn-blue modal-footer-btn" (click)="converFileOk()" nz-button
                            nzType="primary" [disabled]="isDisabled">{{'Download'}}</button>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div class="previewFile" *ngIf="previewFile">
            <div class="table-height">
                <nz-table class="main-table-header" [nzFrontPagination]="false" [nzShowPagination]="false"
                    [nzScroll]="{ y: 'calc(100vh - 27em)' }" #sortTable [nzData]="records"
                    [ngClass]="{'table-loading' : records.length > 0 || isStockLoaded}">
                    <thead>
                        <tr class="tableheader">
                            <!-- <th nzWidth="20px">#</th> -->
                            <th nzWidth="100px" [nzAlign]="'left'"><span class="stock-name-th"> Part
                                    Number</span></th>
                            <th [nzAlign]="'right'" nzWidth="180px">Quantity</th>
                            <th [nzAlign]="'right'" nzWidth="180px">Physical Stock</th>
                            <th [nzAlign]="'right'" nzWidth="250px">Warehouse Physical Stock</th>
                            <th [nzAlign]="'right'" nzWidth="130px">Difference </th>
                            <th [nzAlign]="'right'" nzWidth="150px" nzEllipsis> <span
                                    [nzTooltipArrowPointAtCenter]="true" [nzTooltipPlacement]="['top']"
                                    nz-tooltip>Comment</span></th>
                        </tr>
                    </thead>
                    <tbody [ngClass]="{'has-data' : records.length > 0}">
                        <tr *ngFor="let record of records;let i = index;">
                            <td nzWidth="100px">{{record[0]}}</td>
                            <td [nzAlign]="'right'" nzWidth="180px">{{record[1]}}</td>
                            <td [nzAlign]="'right'" nzWidth="180px">{{record[2] == '' ? 0 : record[2]}}</td>
                            <td [nzAlign]="'right'" nzWidth="250px">{{record[3]}}</td>
                            <td [nzAlign]="'right'" nzWidth="150px">{{record[2] - record[3]}}</td>
                            <td [nzAlign]="'right'" nzWidth="150px">{{record[4]}}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
            <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                <nz-form-item class="mb-0 text-right">
                    <nz-form-control>
                        <button nz-button nzType="default" (click)="physicalInventoryCancel()"
                            class="modal-footer-btn cancel-btn right_margin">Cancel</button>
                        <button class="btn-blue modal-footer-btn" (click)="onUpload()" nz-button
                            nzType="primary">Confirm</button>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </ng-container>
</nz-modal>


<app-audit-history *ngIf="isAuditVisible" [entityType]="entityType" [entityDetails]="entityDetails"
    (hideModal)="hideAuditModal($event)"></app-audit-history>

<app-add-update-assignment *ngIf="isAssignmentVisible" [editAssignmentDetail]="editAssignmentDetail"
    (hideModal)="hideModal($event)">
</app-add-update-assignment>

<nz-modal nzCentered class="custom-modal" nzClassName="addUpateModal" [nzMaskClosable]="false" [(nzVisible)]="isVisiblePartsModal"
    nzTitle="Import Parts" [nzWidth]="1000"
   nzOkText="Save" [nzOkLoading]="isImportingParts"
    nzCancelText="Cancel" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
        <div style="height: 50px;">
        <a class="float-right" nz-button nzSize="large" nzType="link" (click)="downloadFile()">Download
            sample CSV
            file</a>
        </div>
        <div>
        <input type="file" style="display:none" #fileInput (change)="uploadedCSVInfo($event)"
                                accept=".csv">
                            <nz-upload nzType="drag" [nzMultiple]="false" accept=".csv"
                                [nzCustomRequest]="customRequest" nzListType="picture"
                                (nzChange)="handleChange($event)">
                                <p class="ant-upload-drag-icon">
                                    <i nz-icon nzType="inbox"></i>
                                </p>
                                <p class="ant-upload-text"> Choose CSV file <br>OR <br>Drag and
                                    drop CSV file here</p>
                            </nz-upload>
                        </div>
    </ng-container>
</nz-modal>